export function rmTld(domain: string, tld: string) {
  if (!domain) {
    return domain;
  }
  const rg = RegExp('.' + tld + '$');
  return domain.replace(rg, '');
}
